import { useGetClaim } from '@/api'
import { ROUTER_PATHS } from '@/lib/constants'
import { withRequiredPermissions } from '@/lib/permissions'
import { GenerateClaimDocumentForm } from '@eigtech/ui-shared-claims'
import { Spinner } from '@eigtech/ui/components/spinner'
import { createFileRoute, useNavigate } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/claims/$claimNumber/_layout/generate-document')({
  component: () => <Component />,
})

function GenerateDocument() {
  const { claimNumber } = Route.useParams()

  const { data: claim } = useGetClaim(claimNumber)

  const navigate = useNavigate()

  if (!claim) {
    return (
      <div className="flex items-center justify-center">
        <Spinner />
      </div>
    )
  }

  return (
    <GenerateClaimDocumentForm
      claim={claim}
      onSubmitted={(doc) =>
        doc.guidedDocumentType
          ? navigate({
              to: ROUTER_PATHS.claimDetailGenerateDocumentGuided.route,
              params: { claimNumber, guidedDocumentType: doc.guidedDocumentType },
            })
          : navigate({
              to: ROUTER_PATHS.claimDetailGenerateDocumentStatus.route,
              params: { claimNumber, templateId: doc.templateId },
            })
      }
    />
  )
}

const Component = withRequiredPermissions(GenerateDocument, {
  requiredPermissions: [{ action: 'create', subject: 'draftDocument' }],
})
